import IncidentListToolbar from '@/views/incident/toolbars/IncidentListToolbar';
import IncidentViewToolbar from '@/views/incident/toolbars/IncidentViewToolbar';
import IncidentView from '@/views/incident/IncidentView';
import IncidentList from '@/views/incident/IncidentList';
import DefaultLayout from '@/layout/DefaultLayout';
import { STATES } from '@/constants';

export const incidentAnalyzeRoutes = [
  {
    path: '/incident-analyze',
    name: 'incident-analyze',
    components: {
      default: IncidentList,
      toolbar: IncidentListToolbar
    },
    meta: {
      type: STATES.WAITING_DECISION,
      sortBy: 'UPDATED_AT',
      title: 'Ожидающие решения обращения',
      layout: DefaultLayout
    }
  },
  {
    path: '/incident-analyze/:id',
    name: 'incident-analyze-view',
    components: {
      default: IncidentView,
      toolbar: IncidentViewToolbar
    },
    component: IncidentView,
    meta: {
      layout: DefaultLayout,
      type: STATES.WAITING_DECISION
    }
  },
  {
    path: '/incident-analyze/:id/more/:moreId?',
    name: 'incident-analyze-view-more',
    components: {
      default: IncidentView,
      toolbar: IncidentViewToolbar
    },
    component: IncidentView,
    meta: {
      layout: DefaultLayout,
      type: STATES.WAITING_DECISION
    }
  }
];
